import { Injectable } from '@angular/core';
import { CustomerModel } from 'src/app/models/customer-model';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';

@Injectable({
  providedIn: 'root'
})
export class TrackService {

  public customer: CustomerModel;

  constructor(private userSession: UserSessionService,
    private webservice: WebservicesService) {
    this.userSession.getCustomer().subscribe(
      (customer) => {
        this.customer = customer;
      });
  }

  // to track down the abandoning pages (Self exclution) by players
  trackPage(pageName) {
      let obj: any = {
        customer_id: this.customer.customerId,
        session_token: this.userSession.sessionToken,
        page_name: pageName
      };
    return this.webservice.postNoError("configuration/page-view", obj);
  }



}